class CaloriesRecommendationFactory {
  constructor(reommendations) {
    this.reommendations = reommendations;

    this.calculator = null;
    this.recommendation = null;

    this.result = null;

    this.suggestions = {
      target: [],
      training: [],
      activity: [],
      weight: [],
      size: [],
      age: [],
      gender: [],
      kcal: [],
      protein: [],
      carbohydrates: [],
      fat: [],
      bmi: [],
    };

    this.resultSuggestions = {
      bmi_result: [],
    };
  }

  setCalculator(calculator) {
    this.calculator = calculator;
  }

  async _prepareSuggestions() {
    const result = this.calculator.getResult();
    const resultTargets = ['kcal', 'protein', 'carbohydrates', 'fat', 'bmi'];
    const calculatorTargets = ['target', 'training', 'activity', 'weight', 'size', 'age', 'gender'];

    this.reommendations.forEach((recommendation) => {
      const { target, target_value_from, target_value_to } = recommendation;
      const valueFrom = parseFloat(target_value_from);
      const valueTo = parseFloat(target_value_to);

      if (resultTargets.includes(target)) {
        if (this._isInRange(result[target], valueFrom, valueTo)) {
          this.suggestions[target].push(recommendation);
        }
      } else if (calculatorTargets.includes(target)) {
        const value = this.calculator.getValueByTarget(target);
        if (this._isInRange(value, valueFrom, valueTo)) {
          this.suggestions[target].push(recommendation);
        }
      } else if (target === "bmi_result") {
        if (this._isInRange(result.bmi, valueFrom, valueTo)) {
          this.resultSuggestions[target].push(recommendation);
        }
      }
    });
  }

  _isInRange(value, from, to) {
    return value >= from && value <= to;
  }

  async _determineMostValuableRecommendation() {
    const suggestionKeys = ['bmi', 'target', 'training', 'activity', 'weight', 'size', 'age', 'gender', 'kcal', 'protein', 'carbohydrates', 'fat'];

    suggestionKeys.forEach(key => {
      this.suggestions[key].forEach((suggestion) => {
        this.recommendation = this.getMoreValuableSuggeston(this.recommendation, suggestion);
      });
    });
  }

  async _determineMostValuableResult() {
    this.resultSuggestions.bmi_result.forEach((suggestion) => {
      this.result = this.getMoreValuableSuggeston(this.result, suggestion);
    });
  }
  
  getMoreValuableSuggeston(suggestionA, suggestionB) {
    if (suggestionA === null) return suggestionB;
    return suggestionA.target_weight > suggestionB.target_weight ? suggestionA : suggestionB;
  }

  async _determine() {
    await this._prepareSuggestions();
    await this._determineMostValuableRecommendation();
    await this._determineMostValuableResult();
  }

  async _fetchPageData(url, selector) {
    const response = await fetch(url);
    const html = await response.text();
    const parsedHtml = new DOMParser().parseFromString(html, "text/html");
    return JSON.parse(parsedHtml.querySelector(selector).innerText);
  }

  async getRecommendedText() {
    if (this.recommendation === null) {
      await this._determine();
    }
    return this._fetchPageData(
      `${window.Shopify.routes.root}pages/${this.recommendation.page}?section_id=calories-result-page`,
      "[data-page]"
    );
  }

  async getResultText() {
    if (this.recommendation === null) {
      await this._determine();
    }
    return this._fetchPageData(
      `${window.Shopify.routes.root}pages/${this.result.page}?section_id=calories-result-page`,
      "[data-page]"
    );
  }

  async getRecommendedProduct() {
    if (this.recommendation === null) {
      await this._determine();
    }
    return this._fetchPageData(
      `${window.Shopify.routes.root}products/${this.recommendation.product}?section_id=calories-result-product`,
      "[data-product]"
    );
  }
  
  
}
